import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
export abstract class ArbetsorderAtgardBaseCommand extends BasicCommand<ArbetsorderAtgardBaseCommand> {
    arbetsorderId: number;

    get primaryKey(): IPrimaryKey<ArbetsorderAtgardBaseCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }

    constructor($type, commandType) {
        super($type, "ArbetsorderAtgard", commandType);
    }
}
